import { render, staticRenderFns } from "./settings-presets-button.vue?vue&type=template&id=34cb98ba&"
import script from "./settings-presets-button.vue?vue&type=script&lang=js&"
export * from "./settings-presets-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports